import { render, staticRenderFns } from "./InstagramScenarioEditorDialog.vue?vue&type=template&id=45a2f9bb&scoped=true"
import script from "./InstagramScenarioEditorDialog.vue?vue&type=script&setup=true&lang=ts"
export * from "./InstagramScenarioEditorDialog.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./InstagramScenarioEditorDialog.vue?vue&type=style&index=0&id=45a2f9bb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a2f9bb",
  null
  
)

export default component.exports